import React, { useState, useEffect, useRef, useCallback } from 'react';
import '../../../../styles/reset.scss';
import './index.scss';
// import Navbar from '../../../../components/navbar';
// import Message from '../../../../components/message';
// import Button from '../../../../components/button/Button';
import Toast from '../../../../components/toast/Toast';
// import AutoComplete from '../auto-complete';
import Radio from './components/radio';
import Uploadimg from './components/upload-img';
// import Select from './components/select';

import nativeInterface from '../../../../native-interact/native';
// import $http from '../../service/ajax';
// import { getUrlParam, getCookie } from '../../js/utils';
import { getParkList, getOSS, postCallAction } from '../../../../service';
import { getPropertyList, getSerial, submitSerialData } from './data';

function RepairSerial(props) {
  const {
    parkinglotname, parkinglotid, parkingno, oldSerial, projectId, onhideRepair
  } = props;
  console.log('地磁维修上报初始化参数', parkinglotname, parkinglotid, parkingno, oldSerial, projectId);
  // const [parkData, setparkData] = useState([]);

  // const onBack = () => {
  //   Message.confirm('确定退出地磁更换上报？', () => {
  //     nativeInterface.finishActivity();
  //   }, () => {});
  // };

  // const [reasonList, setReasonList] = useState([]);

  const [submitData, setsubmitData] = useState({
    parklotId: parkinglotid, // 车场id
    serial: oldSerial, // 地磁号
    type: '', // 地磁维修类型
    parkingno, // 地磁车位号
    remark: '' // 维修原因详细备注
  });

  // const [serialInfo, setSerialInfo] = useState({
  //   projectId: '',
  //   version: '',
  //   sim: ''
  // });

  const [typelist, setTypelist] = useState([]);

  const [pic, setpic] = useState(['', '', '']); // 本地拍照图片地址
  let currentType = useRef(0);
  const [osspicList, setosspicList] = useState(['', '', '']); // 阿里云保存地址 后台存储用
  useEffect(() => {
    // getParkList().then((res) => {
    //   setparkData(res.records);
    // });

    // getTypeList().then((res) => {
    //   setTypelist(res.data);
    // });

    getPropertyList().then((res) => {
      setTypelist(res.data.list);
    });

    // setReasonList([
    //   { label: '原因1', id: 1 },
    //   { label: '原因2', id: 2 }
    // ]);

    // window.RFID.readSerialCallback = function (...args) {
    //   if (args.length === 0) {
    //     Toast.fail('请检查读卡器摆放位置！');
    //     return;
    //   }
    //   const newsubmitData = { ...submitData };
    //   newsubmitData.serial = args[2];

    //   // 获取地磁的绑定信息
    //   getSerial({
    //     serial: newsubmitData.serial
    //   }).then((res) => {
    //     const data = res.data;
    //     const newSerialInfo = { ...serialInfo };
    //     newSerialInfo.projectId = data.projectId;
    //     newSerialInfo.version = data.version;
    //     newSerialInfo.sim = data.sim;
    //     setSerialInfo(newSerialInfo);

    //     newsubmitData.parkingno = data.parkingno;
    //     setsubmitData(newsubmitData);
    //   });
    // };
  }, []);

  // const onParkChange = (data) => {
  //   setsubmitData(Object.assign({}, submitData, {
  //     parklotId: data.id
  //   }));
  // };
  const onChangeType = useCallback((type, isSelected) => {
    // 做一层原因去重
    const newsubmitData = { ...submitData };
    const typeList = newsubmitData.type.split(',');
    if (isSelected) {
      typeList.push(type);
    } else {
      typeList.splice(typeList.findIndex(item => type === item), 1);
    }
    newsubmitData.type = typeList.join(',');
    setsubmitData(newsubmitData);
  });
  // const changeParkSpace = (e) => {
  //   const newsubmitData = { ...submitData };
  //   newsubmitData.parkingno = e.target.value;
  //   setsubmitData(newsubmitData);
  // };
  // const searchSerialNo = () => {
  //   // 根据车位号查地磁信息
  //   if (!submitData.parklotId) {
  //     Toast.fail('请选择停车场！');
  //   }
  //   if (!submitData.parkingno) {
  //     Toast.fail('请输入车位号！');
  //   }
  //   getSerial({
  //     parklotid: submitData.parklotId,
  //     parkingno: submitData.parkingno
  //   }).then((res) => {
  //     const data = res.data;
  //     const newSerialInfo = { ...serialInfo };
  //     newSerialInfo.projectId = data.projectId;
  //     newSerialInfo.version = data.version;
  //     newSerialInfo.sim = data.sim;
  //     setSerialInfo(newSerialInfo);

  //     const newsubmitData = { ...submitData };
  //     newsubmitData.serial = data.serial;
  //     setsubmitData(newsubmitData);
  //   });
  // };

  // const [selectReasonList, setSelectReasonList] = useState([]);
  // const handleChangeLabel = (label) => {
  //   const newSelectReasonList = [...selectReasonList];
  //   if (!newSelectReasonList.includes(label)) {
  //     newSelectReasonList.push(label);
  //   }
  //   setSelectReasonList(newSelectReasonList);
  // };

  // const changeSerialNo = (e) => {
  //   const newsubmitData = { ...submitData };
  //   newsubmitData.serial = e.target.value;
  //   setsubmitData(newsubmitData);
  // };
  const onChangeRemark = (e) => {
    const newsubmitData = { ...submitData };
    newsubmitData.remark = e.target.value;
    setsubmitData(newsubmitData);
  };

  // const handleSerialNo = () => {
  //   Message.confirm('请确认已将读卡器放置到地磁上方', () => {
  //     读取地磁号 自动填入
  //     const { readSerial } = nativeInterface;
  //     readSerial(1, 'serial\r\n');
  //   }, () => {});
  // };
  const onuploadImg = (imginfo) => {
    currentType = imginfo.picType;

    // 拍照录像回调
    window.captureCallback = function (path, url) {
      // 原生向阿里云上传图片和录音
      getOSS().then((res) => {
        const callResult = nativeInterface.uploadResource(res);
        postCallAction(`调用原生接口上传图片，原生接口${callResult instanceof Error ? '不存在' : '调用成功'}`);
      });
      // 显示图像数组
      const base64Url = `data:image/jpg;base64,${decodeURIComponent(url)}`;
      pic[currentType] = base64Url;
      setpic([...pic]);
      // 上传图像阿里云地址数组
      const ossPath = path.replace(/.*\/(.*)?$/, '$1');
      osspicList[currentType] = ossPath;
      setosspicList([...osspicList]);
    };
  };

  const submit = () => {
    // console.log(submitData);
    if (!submitData.parklotId) {
      Toast.fail('请选择停车场！');
      return;
    }
    // if (!submitData.parkingno) {
    //   Toast.fail('请输入车位号！');
    //   return;
    // }
    // if (!submitData.serial) {
    //   Toast.fail('请先查询地磁号');
    //   return;
    // }
    if (!submitData.type) {
      Toast.fail('请选择更换原因！');
      return;
    }
    const geoActivateAttachList = [];
    for (let i = 0; i < 3; i++) {
      if (osspicList[i] !== '') {
        geoActivateAttachList.push({
          type: 1,
          propertyName: '',
          propertyKey: `photo${i + 1}`,
          propertyValue: osspicList[i]
        });
      }
    }
    const rpReasonList = [...submitData.type.split(',')];
    for (let i = 0; i < rpReasonList.length; i++) {
      if (rpReasonList[i]) {
        geoActivateAttachList.push({
          type: 1,
          propertyName: '',
          propertyKey: 'rp_reason',
          propertyValue: rpReasonList[i]
        });
      }
    }
    if (submitData.remark) {
      geoActivateAttachList.push({
        type: 1,
        propertyName: '',
        propertyKey: 'rp_instruction',
        propertyValue: submitData.remark
      });
    }
    const reaData = {
      parkinglotid,
      projectId,
      serial: submitData.serial,
      operateType: '2',
      parkingno: submitData.parkingno,
      geoActivateAttachList: [...geoActivateAttachList]
    };
    submitSerialData(reaData).then((res) => {
      if (res.errno == '200') {
        Toast.success('上报成功');
        onhideRepair();
      } else {
        Toast.fail('上报失败，请稍后再试！');
      }
    });
  };

  return (
    <div className="repair-serial-content">
      {/* <div className="header-navbar">
        <Navbar
            title={<span>地磁更换</span>}
            onBack={onBack}
        />
      </div> */}
      <div className="repair-serial-main-content">
        {/* <AutoComplete
            placeholder="请选择停车场"
            className="item form-item"
            data={parkData}
            themeType="light"
            uniqKey="id"
            valueKey="name"
            onSelectList={data => onParkChange(data)}
        /> */}
        <div>
          <div className="title-label">车场：{parkinglotname}</div>
          <div className="title-label">车位号：{parkingno}</div>
          {/* <div className="parklot-wrap">
            <input className="parkingno" type="text" pattern="请填写车位号" value={submitData.parkingno} onChange={(e) => { changeParkSpace(e); }} />
            <Button type="primary" onClick={searchSerialNo}>查询地磁</Button>
          </div> */}
        </div>
        <div>
          <div className="title-label">地磁号：{submitData.serial}</div>
          {/* <div style={{ display: 'flex', alignItems: 'center' }}>
            <input className="serialNo" type="text" pattern="请填写磁号" value={submitData.serial} onChange={(e) => { changeSerialNo(e); }} />
            <Button type="primary" onClick={handleSerialNo}>读卡检测</Button>
          </div> */}
        </div>
        {/* 增加读卡操作 蓝牙连接地址后 获取地磁号 根据地磁号获取地磁绑定信息 */}
        {/* <div className="serial-info">
          <div>地磁版本：{serialInfo.version}</div>
          <div>SIM卡号: {serialInfo.sim}</div>
        </div> */}
        <div>
          <div className="title-label">地磁报修原因</div>
          {/* <Select options={reasonList} onSelect={handleChangeLabel} />
          <div className="label-wrap">
            {
              selectReasonList.map((label) => {
                return (
                  <div className="tags" key={label.id}>
                    <div>{label.label}</div>
                  </div>
                );
              })
            }
          </div> */}
          <div>
            <div className="reason-list">
              {
                typelist.map((item) => {
                  return <Radio key={item.id} label={item.titleName} changeType={onChangeType} />;
                })
              }
            </div>
          </div>
        </div>
        <div>
          <div className="title-label">维修原因备注</div>
          <textarea className="remark" name="" id="" rows="4" placeholder="请填写详细的原因说明(选填)" onChange={(e) => { onChangeRemark(e); }}></textarea>
        </div>
        <div className="title-label" style={{ color: '#E6A23C' }}>请将主要内容拍摄到画面中心位置</div>
        {/* <div className="pic-wrap">
          <Uploadimg picType="0" picurl={pic[0]} handleUpload={onuploadImg} />
          <Uploadimg picType="1" picurl={pic[1]} handleUpload={onuploadImg} />
          <Uploadimg picType="2" picurl={pic[2]} handleUpload={onuploadImg} />
        </div> */}
        <div className="pic-wrap-2">
          {/* <div className="title-label">车位环境照</div> */}
          <Uploadimg picType="0" picurl={pic[0]} handleUpload={onuploadImg} />
        </div>
        <div className="pic-wrap-2">
          {/* <div className="title-label">原地磁照</div> */}
          <Uploadimg picType="1" picurl={pic[1]} handleUpload={onuploadImg} />
        </div>
        <div className="pic-wrap-2">
          {/* <div className="title-label">地磁内筒照</div> */}
          <Uploadimg picType="2" picurl={pic[2]} handleUpload={onuploadImg} />
        </div>
        <div className="submit" onClick={submit}>
          确认上报
        </div>
      </div>
    </div>
  );
}

export default RepairSerial;
